import { isPresent } from 'utils/isPresent';
import React from 'react'
import {Field} from "redux-form";
import StateSelectField from "housecall-ui/dist/core/StripeCardElements/StateSelectField";
import {theme} from 'housecall-ui/dist/Theme';

const StateSelectFormField = (props) => (
  <Field
    component={renderStateSelectField}
    {...props}
  />
);

export const renderStateSelectField = ({variant, input, meta, meta: {touched, error}, ...rest}) => {
  const inputProps = variant === 'filled' ? { style: { backgroundColor: theme.palette.grey[100] } } : undefined;

  return <StateSelectField
    {...input}
    {...rest}
    InputProps={inputProps}
    error={touched && isPresent(error)}
    variant={variant}
  />
};

export default React.memo(StateSelectFormField)
